module.exports = __webpack_public_path__ + "logo-light.png?313c695827388cda18808d6f20787a76";